import { Injectable, Provider, StaticProvider } from '@angular/core';
import { CoreOrchestratorViewModelInterface, WingViewModelInterface } from '@nts/std/interfaces';
import { ClassConstructor } from '@nts/std/serialization';

@Injectable()
export class ViewModelLocator {

    private static _registeredDomainModelNameOrchestratorViewModelType = new Map<string, ClassConstructor<CoreOrchestratorViewModelInterface>>();
    private static _registeredOrchestratorViewModelProviders = new Map<any, Provider[]>();
    private static _registeredZoomOrchestratorViewModelProviders: StaticProvider[];
    private static _registeredOrchestratorViewModelWingViewModel = new Map<any, ClassConstructor<WingViewModelInterface>>();

    static getOrchestratorViewModelType(domainModelName: string): ClassConstructor<CoreOrchestratorViewModelInterface> | undefined {
        return ViewModelLocator._registeredDomainModelNameOrchestratorViewModelType.get(domainModelName?.toLowerCase());
    }

    static getOrchestratorViewModelProviders(
        orchestratorViewModelType: ClassConstructor<CoreOrchestratorViewModelInterface>
    ) {
        return ViewModelLocator._registeredOrchestratorViewModelProviders.get(orchestratorViewModelType);
    }

    static registerOrchestratorViewModelWingViewModel(
        orchestratorViewModelType: ClassConstructor<CoreOrchestratorViewModelInterface>,
        wingViewModelType: ClassConstructor<WingViewModelInterface>
    ) {
        ViewModelLocator._registeredOrchestratorViewModelWingViewModel.set(orchestratorViewModelType, wingViewModelType);
    }

    static getWingViewModelType(
        orchestratorViewModelType: ClassConstructor<CoreOrchestratorViewModelInterface>
    ): ClassConstructor<WingViewModelInterface> | undefined {
        return ViewModelLocator._registeredOrchestratorViewModelWingViewModel.get(orchestratorViewModelType);
    }

    static registerDomainModelNameOrchestratorViewModel(
        domainModelName: string,
        orchestratorViewModelType: ClassConstructor<CoreOrchestratorViewModelInterface>,
    ) {
        ViewModelLocator._registeredDomainModelNameOrchestratorViewModelType.set(domainModelName, orchestratorViewModelType);
    }

    static registerZoomOrchestratorViewModelProviders(providers: StaticProvider[]) {
        ViewModelLocator._registeredZoomOrchestratorViewModelProviders = providers;
    }

    static getZoomOrchestratorViewModelProviders() {
        return ViewModelLocator._registeredZoomOrchestratorViewModelProviders;
    }
}
